import Big from 'big.js'

function calculationFreight(options) {
	/**
	 * 计算规则：单价 * 计费重 + 挂号费 + 税 + 其他 = 运费
	 *  计费重是 输入的重量 和 材积重 取最大值
	 *  材积重 = 长 * 宽 * 高 / 材积系数
	 *
	 *  实际税 = 税 * 实际重量
	 */
	try {
		const UnitPrice = options.UnitPrice || 1 //单价
		const RegisterNum = options.RegisterNum || 1 //挂号费
		const OtherNum = options.OtherNum || 0 //其他

		const VolumeNum = options.VolumeNum || 0 // 体积系数.

		let volumeWeight = 0
		if (VolumeNum !== 0) volumeWeight = options.inputVolume.div(VolumeNum) // 材积重
		const actualWeight = Math.max(volumeWeight, options.inputWeight) // 计费重

		const TaxNum = options.TaxNum || 0 //税
		const actualTax = TaxNum * actualWeight // 实际税

		const resultValue = new Big(UnitPrice)
			.times(actualWeight)
			.plus(RegisterNum)
			.plus(actualTax)
			.plus(OtherNum)
			.toNumber()
		return resultValue
	} catch (error) {
		console.log(error)
		return 1
	}
}

// 运费多结果时取最小值
const calculationRules = {
	GB() {
		// 英国
		let resultValue1 = 0
		if (this.initWeight <= 2 && this.longestSide < 60) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue < 90) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 16, //挂号费
					UnitPrice: 66, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		let resultValue2 = 0
		if (
			this.initWeight <= 20 &&
			this.longestSide <= 60 &&
			this.value1 <= 40 &&
			this.value2 <= 40
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 16, //挂号费
				UnitPrice: 60, //单价
				TaxNum: 0, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue2 = calculationFreight(valueData)
		}

		let resultValue3 = 0
		if (
			this.initWeight >= 2 &&
			this.initWeight <= 30 &&
			this.longestSide < 170
		) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 295) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 59, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue3 = calculationFreight(valueData)
			}
		}

		let resultValue4 = 0
		if (this.initWeight <= 30) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue >= 295 && sizeValue < 400) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 59, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 450, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue4 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [
			resultValue1,
			resultValue2,
			resultValue3,
			resultValue4,
		].filter((item) => item > 0)
		console.log('GB::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	DE() {
		// 德国
		let resultValue1 = 0
		if (this.initWeight <= 2 && this.longestSide < 60) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue < 90) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 21, //挂号费
					UnitPrice: 63, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		let resultValue2 = 0
		if (
			this.initWeight >= 2 &&
			this.initWeight <= 30 &&
			this.longestSide <= 60 &&
			this.value1 <= 40 &&
			this.value2 <= 40
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 21, //挂号费
				UnitPrice: 61, //单价
				TaxNum: 0, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue2 = calculationFreight(valueData)
		}

		let resultValue3 = 0
		if (this.initWeight <= 30 && this.longestSide < 170) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 295) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 49, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue3 = calculationFreight(valueData)
			}
		}

		let resultValue4 = 0
		if (this.initWeight <= 30) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue >= 295 && sizeValue < 400) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 49, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 550, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue4 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [
			resultValue1,
			resultValue2,
			resultValue3,
			resultValue4,
		].filter((item) => item > 0)
		console.log('DE::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	FR() {
		// 法国
		let resultValue1 = 0
		if (this.initWeight <= 2 && this.longestSide < 60) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue < 90) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 23, //挂号费
					UnitPrice: 73, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		let resultValue2 = 0
		if (
			this.initWeight <= 30 &&
			this.longestSide <= 60 &&
			this.value1 <= 40 &&
			this.value2 <= 40
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 23, //挂号费
				UnitPrice: 61, //单价
				TaxNum: 0, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue2 = calculationFreight(valueData)
		}

		let resultValue3 = 0
		if (this.initWeight <= 30 && this.longestSide < 170) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 295) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 69, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue3 = calculationFreight(valueData)
			}
		}

		let resultValue4 = 0
		if (this.initWeight <= 30) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue >= 295 && sizeValue < 400) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 69, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 550, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue4 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [
			resultValue1,
			resultValue2,
			resultValue3,
			resultValue4,
		].filter((item) => item > 0)
		console.log('FR::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	IT() {
		// 意大利
		let resultValue1 = 0
		if (this.initWeight <= 2 && this.longestSide < 60) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue < 90) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 22, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		let resultValue2 = 0
		if (
			this.initWeight <= 30 &&
			this.longestSide <= 60 &&
			this.value1 <= 40 &&
			this.value2 <= 40
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 23, //挂号费
				UnitPrice: 66, //单价
				TaxNum: 0, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue2 = calculationFreight(valueData)
		}

		let resultValue3 = 0
		if (this.initWeight <= 30 && this.longestSide < 170) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 295) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 104, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue3 = calculationFreight(valueData)
			}
		}

		let resultValue4 = 0
		if (this.initWeight <= 30) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue >= 295 && sizeValue < 400) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 104, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 550, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue4 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [
			resultValue1,
			resultValue2,
			resultValue3,
			resultValue4,
		].filter((item) => item > 0)
		console.log('IT::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	ES() {
		// 西班牙
		let resultValue1 = 0
		if (this.initWeight <= 2 && this.longestSide < 60) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue < 90) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 18, //挂号费
					UnitPrice: 69, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		let resultValue2 = 0
		if (
			this.initWeight <= 30 &&
			this.longestSide <= 60 &&
			this.value1 <= 40 &&
			this.value2 <= 40
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 18, //挂号费
				UnitPrice: 61, //单价
				TaxNum: 0, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue2 = calculationFreight(valueData)
		}

		let resultValue3 = 0
		if (this.initWeight <= 30 && this.longestSide < 170) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 295) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 84, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue3 = calculationFreight(valueData)
			}
		}

		let resultValue4 = 0
		if (this.initWeight <= 30) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue >= 295 && sizeValue < 400) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 84, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 450, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue4 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [
			resultValue1,
			resultValue2,
			resultValue3,
			resultValue4,
		].filter((item) => item > 0)
		console.log('ES::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	NL() {
		// 荷兰
		let resultValue1 = 0
		if (this.initWeight <= 2 && this.longestSide < 50) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue < 90) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 20, //挂号费
					UnitPrice: 81, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		let resultValue2 = 0
		if (
			this.initWeight <= 20 &&
			this.longestSide <= 60 &&
			this.value1 <= 40 &&
			this.value2 <= 40
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 21, //挂号费
				UnitPrice: 69, //单价
				TaxNum: 0, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue2 = calculationFreight(valueData)
		}

		let resultValue3 = 0
		if (this.initWeight <= 30 && this.longestSide < 170) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 295) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 49, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue3 = calculationFreight(valueData)
			}
		}

		let resultValue4 = 0
		if (this.initWeight <= 30) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue >= 295 && sizeValue < 400) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 49, //挂号费
					UnitPrice: 72, //单价
					TaxNum: 6.75, //税
					OtherNum: 450, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue4 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [
			resultValue1,
			resultValue2,
			resultValue3,
			resultValue4,
		].filter((item) => item > 0)
		console.log('NL::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	SE() {
		// 瑞典
		let resultValue1 = 0
		if (
			this.initWeight <= 20 &&
			this.longestSide <= 60 &&
			this.value1 <= 40 &&
			this.value2 <= 40
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 25, //挂号费
				UnitPrice: 83, //单价
				TaxNum: 0, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue1 = calculationFreight(valueData)
		}

		const resultValueArr = [resultValue1].filter((item) => item > 0)
		console.log('SE::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	PL() {
		// 波兰
		let resultValue1 = 0
		if (
			this.initWeight <= 20 &&
			this.longestSide <= 60 &&
			this.value1 <= 40 &&
			this.value2 <= 40
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 16, //挂号费
				UnitPrice: 64, //单价
				TaxNum: 0, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue1 = calculationFreight(valueData)
		}
		const resultValueArr = [resultValue1].filter((item) => item > 0)
		console.log('PL::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	SA() {
		// 沙特阿拉伯
		let resultValue1 = 0
		if (
			this.initWeight <= 20 &&
			this.longestSide <= 60 &&
			this.value1 <= 40 &&
			this.value2 <= 40
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 65, //挂号费
				UnitPrice: 75, //单价
				TaxNum: 0, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue1 = calculationFreight(valueData)
		}
		const resultValueArr = [resultValue1].filter((item) => item > 0)
		console.log('SA::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	US() {
		// 美国
		let resultValue1 = 0
		if (
			this.initWeight <= 0.7 &&
			this.longestSide <= 68 &&
			this.value1 <= 43 &&
			this.value2 <= 43
		) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue < 195) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 18, //挂号费
					UnitPrice: 110, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		let resultValue2 = 0
		if (
			this.initWeight >= 0.7 &&
			this.initWeight <= 30 &&
			this.longestSide <= 68 &&
			this.value1 <= 43 &&
			this.value2 <= 43
		) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 195) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 11, //挂号费
					UnitPrice: 100, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue2 = calculationFreight(valueData)
			}
		}

		let resultValue3 = 0
		if (this.initWeight <= 30 && this.longestSide <= 100) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue > 195 && sizeValue < 270) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 11, //挂号费
					UnitPrice: 100, //单价
					TaxNum: 0, //税
					OtherNum: 30, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue3 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [
			resultValue1,
			resultValue2,
			resultValue3,
		].filter((item) => item > 0)
		console.log('US::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},

	CA() {
		// 加拿大
		let resultValue1 = 0
		if (this.initWeight <= 30 && this.longestSide < 150) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 295) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 40, //挂号费
					UnitPrice: 120, //单价
					TaxNum: 6.75, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [resultValue1].filter((item) => item > 0)
		console.log('CA::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	MX() {
		// 墨西哥
		let resultValue1 = 0
		if (
			this.initWeight <= 70 &&
			this.longestSide <= 80 &&
			this.value1 <= 80 &&
			this.value2 <= 80
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 21, //挂号费
				UnitPrice: 130, //单价
				TaxNum: 6.75, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue1 = calculationFreight(valueData)
		}

		const resultValueArr = [resultValue1].filter((item) => item > 0)
		console.log('MX::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	JP() {
		// 日本
		let resultValue1 = 0
		if (this.initWeight <= 2 && this.longestSide < 60) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue < 90) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 15, //挂号费
					UnitPrice: 44, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		let resultValue2 = 0
		if (this.initWeight <= 30 && this.longestSide <= 125) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 275) {
				const valueData = {
					VolumeNum: 6000, // 体积系数
					RegisterNum: 70, //挂号费
					UnitPrice: 40, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue2 = calculationFreight(valueData)
			}
		}

		let resultValue3 = 0
		if (this.initWeight <= 30) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue <= 160) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 33, //挂号费
					UnitPrice: 50, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue3 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [
			resultValue1,
			resultValue2,
			resultValue3,
		].filter((item) => item > 0)
		console.log('JP::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	AU() {
		// 澳洲
		let resultValue1 = 0
		if (this.initWeight <= 20 && this.longestSide < 105) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(this.value2)
			if (sizeValue < 105) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 25, //挂号费
					UnitPrice: 83, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [resultValue1].filter((item) => item > 0)
		console.log('AU::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	AE() {
		// 阿联酋
		let resultValue1 = 0
		if (this.initWeight <= 20) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue < 110) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 30, //挂号费
					UnitPrice: 48, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		const resultValueArr = [resultValue1].filter((item) => item > 0)
		console.log('AE::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	SG() {
		// 新加坡
		let resultValue1 = 0
		if (this.initWeight <= 1.5 && this.longestSide < 60) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue < 90) {
				const valueData = {
					VolumeNum: 0, // 体积系数
					RegisterNum: 15, //挂号费
					UnitPrice: 44, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		let resultValue2 = 0
		if (
			this.initWeight >= 1.5 &&
			this.initWeight <= 30 &&
			this.longestSide < 125
		) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 275) {
				const valueData = {
					VolumeNum: 6000, // 体积系数
					RegisterNum: 70, //挂号费
					UnitPrice: 27, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue2 = calculationFreight(valueData)
			}
		}
		const resultValueArr = [resultValue1, resultValue2].filter(
			(item) => item > 0
		)
		console.log('SG::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	IN() {
		// 印度
		let resultValue1 = 0
		if (this.initWeight <= 5 && this.longestSide < 150) {
			// 尺寸相加的值
			const sizeValue = this.longestSide
				.plus(this.value1)
				.plus(this.value2)
			if (sizeValue < 200) {
				const valueData = {
					VolumeNum: 8000, // 体积系数
					RegisterNum: 10, //挂号费
					UnitPrice: 80, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue1 = calculationFreight(valueData)
			}
		}

		let resultValue2 = 0
		if (
			this.initWeight >= 5 &&
			this.initWeight <= 30 &&
			this.longestSide <= 60
		) {
			// 尺寸相加的值
			const sizeValue = this.longestSide.plus(
				this.value1.plus(this.value2).times(2)
			)
			if (sizeValue <= 120) {
				const valueData = {
					VolumeNum: 6000, // 体积系数
					RegisterNum: 24.5, //挂号费
					UnitPrice: 43, //单价
					TaxNum: 0, //税
					OtherNum: 0, //其他
					inputVolume: this.longestSide
						.times(this.value1)
						.times(this.value2), // 根据输入的长宽高计算的体积
					inputWeight: this.initWeight,
				}
				resultValue2 = calculationFreight(valueData)
			}
		}
		const resultValueArr = [resultValue1, resultValue2].filter(
			(item) => item > 0
		)
		console.log('IN::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
	BR() {
		// 巴西
		let resultValue1 = 0
		if (
			this.initWeight <= 30 &&
			this.longestSide <= 150 &&
			this.value1 <= 150 &&
			this.value2 <= 150
		) {
			const valueData = {
				VolumeNum: 8000, // 体积系数
				RegisterNum: 34, //挂号费
				UnitPrice: 105, //单价
				TaxNum: 0, //税
				OtherNum: 0, //其他
				inputVolume: this.longestSide
					.times(this.value1)
					.times(this.value2), // 根据输入的长宽高计算的体积
				inputWeight: this.initWeight,
			}
			resultValue1 = calculationFreight(valueData)
		}
		const resultValueArr = [resultValue1].filter((item) => item > 0)
		console.log('SA::', resultValueArr)
		if (resultValueArr.length) return Math.min(...resultValueArr)
		return 0
	},
}

class FreightCalculation {
	constructor(options) {
		const { purchasePrice, weight, length, width, height } = options

		this.initPurchasePrice = Number(purchasePrice)
		this.initWeight = Number(weight)
		this.initLength = Number(length)
		this.initWidth = Number(width)
		this.initHeight = Number(height)

		this.initValue()
	}

	initValue() {
		const sizeArr = [
			this.initLength,
			this.initWidth,
			this.initHeight,
		].sort()

		this.value1 = new Big(sizeArr[0]) // 除了最长边剩余的两个值
		this.value2 = new Big(sizeArr[1]) // 除了最长边剩余的两个值
		this.longestSide = new Big(sizeArr[2]) // 最长边
	}

	getCalculationValue(countryTag) {
		//   console.log(countryTag)
		return calculationRules[countryTag].call(this)
	}
}

export default FreightCalculation
